import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://mm-webstudio.com",
  target: "_blank",
  title: "mm-webstudio"
}, "mm-webstudio", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, {
    fluid: "",
    class: "footer-panel"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_row, { class: "background-color" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, {
            lg: "6",
            class: "font-color text-align-left copyright-position"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" © Copyright 2024 | All rights reserved ")
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, {
            lg: "6",
            class: "font-color text-align-right powered-position"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Powered by: "),
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}